"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _Modal = require("@insided/shared/uikit/Modal");

var _PillContainer = _interopRequireDefault(require("@insided/deprecated-preact-components/pills/PillContainer"));

var _Pill = _interopRequireDefault(require("@insided/deprecated-preact-components/pills/Pill"));

var _ChooseRecipientsPanel = require("@insided/deprecated-control/EmailCampaigns/components/panels/ChooseRecipientsPanel");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EmailTypeAndRecipients = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EmailTypeAndRecipients, _Component);

  var _super = _createSuper(EmailTypeAndRecipients);

  function EmailTypeAndRecipients(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EmailTypeAndRecipients);
    _this = _super.call(this, props);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  (0, _createClass2.default)(EmailTypeAndRecipients, [{
    key: "getDisplayAppliedFilters",
    value: function getDisplayAppliedFilters() {
      var _this$props$filters$f, _this$props$filters;

      var audienceFilter = this.props.audienceFilter;
      var filters = (_this$props$filters$f = (_this$props$filters = this.props.filters) === null || _this$props$filters === void 0 ? void 0 : _this$props$filters.filter(function (filter) {
        return filter.type === 'filter';
      })) !== null && _this$props$filters$f !== void 0 ? _this$props$filters$f : [];
      if (!audienceFilter) return [];
      if (!(0, _ChooseRecipientsPanel.isFiltersList)(audienceFilter)) return [];
      var appliedFilters = audienceFilter.data;
      if (!appliedFilters) return [];
      return Object.keys(appliedFilters).filter(function (key) {
        // ignore search
        if (key === 'search') {
          return false;
        }

        if (key === 'mainRoles') {
          return appliedFilters[key].length > 0;
        }

        var value = appliedFilters[key]; // ignore empty arrays

        if (Array.isArray(value) && !value.length) {
          return false;
        }

        return value === false || !!value;
      }).map(function (key) {
        var values = appliedFilters[key];
        var filter = filters.find(function (filter) {
          return (filter === null || filter === void 0 ? void 0 : filter.id) === key;
        });
        return {
          id: filter === null || filter === void 0 ? void 0 : filter.id,
          filter: key,
          name: filter === null || filter === void 0 ? void 0 : filter.name,
          pillValue: filter === null || filter === void 0 ? void 0 : filter.getPillDisplayValue(values)
        };
      });
    }
  }, {
    key: "renderModalBody",
    value: function renderModalBody() {
      var _this$props = this.props,
          campaignType = _this$props.campaignType,
          audienceFilter = _this$props.audienceFilter;

      if (!audienceFilter) {
        return null;
      }

      var filters = this.getDisplayAppliedFilters();
      return (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)("div", {
        style: {
          marginBottom: 12
        }
      }, campaignType === 'automated' ? 'Sent once users match these criteria:' : 'Users that matched these criteria:'), (0, _preact.h)(_PillContainer.default, null, filters.map(function (filter) {
        return (0, _preact.h)(_Pill.default, {
          newStyle: true,
          key: filter.id
        }, (0, _preact.h)("div", {
          className: "truncated"
        }, (0, _preact.h)("span", {
          className: "filter-type"
        }, filter.name), (0, _preact.h)("span", {
          className: "filter-value"
        }, filter.pillValue)));
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _allSegments$find$tit,
          _allSegments$find,
          _this2 = this;

      var isOpen = this.state.isOpen;
      var _this$props2 = this.props,
          campaignType = _this$props2.campaignType,
          audienceFilter = _this$props2.audienceFilter,
          segmentGroups = _this$props2.segmentGroups;
      var allSegments = segmentGroups.map(function (_ref) {
        var _ref$segments = _ref.segments,
            segments = _ref$segments === void 0 ? [] : _ref$segments;
        return segments;
      }).reduce(function (allSegments, currentSegments) {
        return [].concat((0, _toConsumableArray2.default)(allSegments), (0, _toConsumableArray2.default)(currentSegments));
      }, []);
      return (0, _preact.h)("div", {
        className: "email-campaigns__view__info-boxes"
      }, (0, _preact.h)("div", {
        className: "email-campaigns__view__info-box"
      }, (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
        icon: "oneOffEmail",
        color: "#0069FF"
      })), (0, _preact.h)("div", {
        className: "box-body"
      }, (0, _preact.h)("div", {
        className: "box-title"
      }, "Email type"), (0, _preact.h)("div", {
        className: "box-content"
      }, campaignType === 'automated' ? 'Automated email' : 'One-off email'))), (0, _preact.h)("div", {
        className: "email-campaigns__view__info-box"
      }, (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
        icon: "usersPlus",
        color: "#0069FF"
      })), (0, _preact.h)("div", {
        className: "box-body"
      }, (0, _preact.h)("div", {
        className: "box-title"
      }, "Recipients"), (0, _preact.h)("div", {
        className: "box-content"
      }, audienceFilter && (0, _ChooseRecipientsPanel.isFiltersSegment)(audienceFilter) ? (0, _preact.h)("div", null, "Segment: ", (0, _preact.h)("strong", null, (_allSegments$find$tit = (_allSegments$find = allSegments.find(function (_ref2) {
        var id = _ref2.id;
        return "".concat(id) === audienceFilter.data;
      })) === null || _allSegments$find === void 0 ? void 0 : _allSegments$find.title) !== null && _allSegments$find$tit !== void 0 ? _allSegments$find$tit : ''), ' ', (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/users/segments/".concat(audienceFilter.data)),
        target: "_blank",
        rel: "noreferrer",
        className: "button-link",
        "data-track-type": "click",
        "data-element-name": "View segment link"
      }, "View segment")) : (0, _preact.h)("div", null, (0, _preact.h)("button", {
        className: "button-link",
        onClick: function onClick() {
          return _this2.setState({
            isOpen: true
          });
        },
        "data-track-type": "click",
        "data-element-name": "View criteria button"
      }, "View criteria"), (0, _preact.h)(_Modal.Modal, {
        isOpen: isOpen,
        size: "small",
        className: "email-campaigns__view__info-box__recipients"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        onClose: function onClose() {
          return _this2.setState({
            isOpen: false
          });
        },
        title: "Recipients"
      }), this.renderModalBody()))))));
    }
  }]);
  return EmailTypeAndRecipients;
}(_preact.Component);

exports.default = EmailTypeAndRecipients;